// src/components/Footer.jsx
import React from "react";
import { Link } from "react-router-dom";
import "./footer.css";

/* ────────────────────────────────────────────────────────────── */
/* Helper: social icon with accessible label                     */
/* ────────────────────────────────────────────────────────────── */
const Social = ({ href, icon, label }) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    aria-label={label}
    className={`fab fa-${icon}`}
  >
    <span className="sr-only">{label}</span>
  </a>
);

/* ────────────────────────────────────────────────────────────── */
/* Footer component                                              */
/* ────────────────────────────────────────────────────────────── */
export default function Footer() {
  return (
    <footer className="footer">
      <div className="footer-grid">
        {/* ─── Quick Links ───────────────────────── */}
        <div className="footer-column">
          <h4>Quick Links</h4>
          <ul className="footer-links">
            <li>
              <Link to="/">
                <i className="fas fa-angle-right" /> Home
              </Link>
            </li>
            <li>
              <Link to="/about">
                <i className="fas fa-angle-right" /> About&nbsp;Us
              </Link>
            </li>
            <li>
              <Link to="/services">
                <i className="fas fa-angle-right" /> Services
              </Link>
            </li>
            <li>
              <Link to="/projects">
                <i className="fas fa-angle-right" /> Projects
              </Link>
            </li>
            <li>
              <Link to="/contact">
                <i className="fas fa-angle-right" /> Contact
              </Link>
            </li>
            <li>
              <Link to="/share-your-experience">
                <i className="fas fa-star" /> Leave&nbsp;a&nbsp;Review
              </Link>
            </li>
          </ul>
        </div>

        {/* ─── Our Services (exact sub-routes) ───── */}
        <div className="footer-column">
          <h4>Our Services</h4>
          <ul className="footer-links">
            <li>
              <Link to="/services/electrical-wiring">
                <i className="fas fa-bolt" /> Electrical&nbsp;Wiring
              </Link>
            </li>
            <li>
              <Link to="/services/lighting-installation">
                <i className="fas fa-lightbulb" /> Lighting&nbsp;Installation
              </Link>
            </li>
            <li>
              <Link to="/services/circuit-design">
                <i className="fas fa-project-diagram" /> Circuit&nbsp;Design
              </Link>
            </li>
            <li>
              <Link to="/services/power-backup-systems">
                <i className="fas fa-car-battery" /> Power&nbsp;Backup
              </Link>
            </li>
            <li>
              <Link to="/services/safety-inspection-compliance">
                <i className="fas fa-shield-alt" /> Safety&nbsp;Inspection
              </Link>
            </li>
          </ul>
        </div>

        {/* ─── Contact ───────────────────────────── */}
        <div className="footer-column">
          <h4>Contact Us</h4>
          <ul className="footer-links">
            <li>
              <a href="tel:+27824989477">
                <i className="fas fa-phone-alt" /> +27&nbsp;82&nbsp;498&nbsp;9477
              </a>
            </li>
            <li>
              <a href="mailto:info@mosikeelectrical.com">
                <i className="fas fa-envelope" /> info@mosikeelectrical.com
              </a>
            </li>
          </ul>
          <p className="footer-address">
            <i className="fas fa-map-marker-alt" /> 59A Kirkness Rd,&nbsp;The Orchards X10&nbsp;0182
          </p>
          <p className="footer-address">
            <i className="fas fa-map-marker-alt" /> Buffalo Thorn Cres, Woodlands Estate, Polokwane, 0713, South Africa
          </p>

          <h4 style={{ marginTop: "2rem" }}>Connect With Us</h4>
          <div className="social-links">
            <Social
              href="https://www.facebook.com/share/1DVgT2UucB/?mibextid=wwXIfr"
              icon="facebook-f"
              label="Facebook"
            />
            <Social
              href="https://www.instagram.com/mosikeelec_"
              icon="instagram"
              label="Instagram"
            />
            <Social
              href="https://www.linkedin.com/company/mosike-electrical-contractors/"
              icon="linkedin-in"
              label="LinkedIn"
            />
          </div>
        </div>

        {/* ─── About ─────────────────────────────── */}
        <div className="footer-column">
          <h4>About Mosike</h4>
          <p>
            Mosike Electrical Contractors delivers safe, energy-efficient
            electrical and automation solutions to homes, industry and public
            infrastructure across Southern Africa.
          </p>
          <Link to="/about" className="btn">
            Learn More
          </Link>
        </div>
      </div>

      {/* ─── Copyright ──────────────────────────── */}
      <div className="copyright">
        <p>© 2002 Mosike Electrical Contractors. All Rights Reserved.</p>
      </div>
    </footer>
  );
}
